/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Col, Row } from 'react-bootstrap';
import { MdAccountCircle } from 'react-icons/md';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import {
  API_DATE_FORMAT,
  checkValidName,
  checkValidPassport,
  TODAY_DATE,
} from '../../../shared/constants/Constants';
import {
  formatDate,
  getNewDate,
  isEmpty,
  isMobileWidth,
} from '../../../shared/helper-utils/appUtils';
import AppIconButton from '../../../shared/components/app-icon-button/AppIconButton';
import AppSidebar from '../../../shared/components/app-sidebar/AppSidebar';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import { subYears } from 'date-fns';
import { getValueFromAppConfig } from '../../../shared/helper-utils/localStorage';

function HotelPassengerDetails({
  passengerList,
  onPassengerUpdate,
  passengerErrorDict,
  isPassport,
  isPan,
}) {
  const intl = useIntl();
  const formattedMessage = (message) => intl.formatMessage({ id: message });

  const [passengers, setPassengers] = useState(passengerList);
  const [showAddPax, setShowAddPax] = useState(false);
  const [selectedPax, setSelectedPax] = useState({});
  const [alert, setAlert] = useState(undefined);
  const [errors, setErrors] = useState({});
  const selectedRoomIndex = useRef(-1);
  const selectedPaxPIndex = useRef(-1);

  const TITLE_OPTIONS = [
    { label: formattedMessage('mr'), value: 'Mr' },
    { label: formattedMessage('ms'), value: 'Ms' },
    { label: formattedMessage('mrs'), value: 'Mrs' },
  ];
  const CHILD_TITLE_OPTIONS = [
    { label: formattedMessage('mstr'), value: 'Mstr' },
    { label: formattedMessage('ms'), value: 'Ms' },
  ];

  useEffect(() => {
    if (onPassengerUpdate) {
      onPassengerUpdate(passengers);
    }
  }, [passengers]);

  const getKey = (roomIndex, room, paxIndex) =>
    roomIndex * room.roomPassengers.paxList.length + paxIndex;

  const handleDropdownChange = (value, name, roomIndex, paxIndex) => {
    const updatedValue = value !== null ? value.value : '';
    const roomList = [...passengers];
    roomList[roomIndex].roomPassengers.paxList[paxIndex][name] = updatedValue;
    setPassengers(roomList);
  };

  const handleChange = (event, roomIndex, paxIndex) => {
    const { name, value } = event.target;
    const roomList = [...passengers];
    roomList[roomIndex].roomPassengers.paxList[paxIndex][name] = value;
    setPassengers(roomList);
  };

  const hasDuplicatePanCardNumber = () => {
    // try {
    //   let hasDupe = false;
    //   const pan = passengers.reduce((acc, cur) => {
    //     const childpan = cur.roomPassengers.paxList
    //       .filter((x) => !isEmpty(x.panCardNumber))
    //       .map((x) => x.panCardNumber);
    //     return acc.concat(childpan);
    //   }, []);
    //   hasDupe = new Set(pan).size !== pan.length;
    //   return hasDupe;
    // } catch (error) {
    //   return false;
    // }
    try {
      const allPANs = [];

      passengers.forEach((room) => {
        room.roomPassengers.paxList.forEach((p) => {
          if (!isEmpty(p.panCardNumber)) {
            allPANs.push(p.panCardNumber.trim());
          }
        });
      });

      // also include current typing in popup
      if (selectedPax.panCardNumber) {
        allPANs.push(selectedPax.panCardNumber.trim());
      }

      // If set size differs → duplicates exist
      return new Set(allPANs).size !== allPANs.length;
    } catch (error) {
      return false;
    }
  };

  const handleShowAddPax = (pax, index, pIndex) => {
    selectedRoomIndex.current = index;
    selectedPaxPIndex.current = pIndex;
    setSelectedPax({ ...pax });
    setErrors({});
    setShowAddPax(true);
  };

  const handleSelectedTitleSelect = (event) => {
    setSelectedPax((prev) => ({
      ...prev,
      title: event ? event.value : '',
    }));
  };

  const handleTravellerInputChange = (event) => {
    const { name, value } = event.target;
    setSelectedPax((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddPax = () => {
    const newErrors = {};
    if (!selectedPax.title) {
      newErrors.title = 'Please select title';
    }

    if (!selectedPax.firstName) {
      newErrors.firstName = 'Please enter first name';
    }

    if (!selectedPax.lastName) {
      newErrors.lastName = 'Please enter last name';
    }

    if (selectedPax.paxType !== '1' && !selectedPax.dob) {
      newErrors.dob = 'Please enter Date of Birth';
    }

    if (isPassport && !selectedPax.ppNumber) {
      newErrors.ppNumber = 'Please enter passport number';
    }

    if (isPassport && !selectedPax.ppExpiry) {
      newErrors.ppExpiry = 'Please enter passport expiry date';
    }

    if (isPan && selectedPax.paxType === '1' && !selectedPax.panCardNumber) {
      newErrors.panCardNumber = 'Please enter PAN number';
    }

    if (isPan && selectedPax.paxType === '1' && hasDuplicatePanCardNumber()) {
      newErrors.panCardNumber =
        'This PAN number already exists for another traveller.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setErrors({});

    const updatedPassengers = [...passengers];
    updatedPassengers[selectedRoomIndex.current].roomPassengers.paxList[
      selectedPaxPIndex.current
    ] = selectedPax;
    setPassengers(updatedPassengers);
    setShowAddPax(false);
  };

  const PAN_REGAX = /^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/;
  return (
    <section>
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => setAlert(undefined)}
        />
      )}
      {isMobileWidth() ? (
        <Row className="spacing-16 custom-form">
          {passengers.map((room, index) => (
            <Col lg={12} key={index}>
              <Row className="spacing-16">
                <Col lg={12}>
                  <span style={{ fontWeight: 500 }}>{`${formattedMessage(
                    'room',
                  )} ${index + 1}:`}</span>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    {room.roomPassengers.paxList.map((pax, pIndex) => {
                      const error =
                        passengerErrorDict[getKey(index, room, pIndex)] || {};
                      const errorText = Object.values(error)[0];
                      return (
                        <div key={pIndex}>
                          <div className="m-2 d-flex justify-content-between align-items-center border-bottom-2">
                            <div className="fs-16 fw-500 p-2 align-items-center">
                              {pax.title || pax.firstName || pax.lastName ? (
                                `${pax.title} ${pax.firstName} ${pax.lastName}`
                              ) : (
                                <span className="fs-14 grey-color">
                                  Traveller {pIndex + 1}
                                </span>
                              )}
                            </div>
                            <AppIconButton
                              onClick={() =>
                                handleShowAddPax(pax, index, pIndex)
                              }
                              variant="transparent"
                              className="p-2 d-flex justify-content-center align-items-center fs-14"
                            >
                              <div className="d-flex align-items-center gap-1 primary-color">
                                <MdAccountCircle className="primary-color" />
                                {pax.title ? 'Edit' : 'Add'}
                              </div>
                            </AppIconButton>
                          </div>
                          {errorText && (
                            <div className="px-2 pb-2">
                              <small className="app-error-text">
                                Please add traveller details
                              </small>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            </Col>
          ))}
        </Row>
      ) : (
        <Row className="spacing-16 custom-form">
          {passengers.map((room, index) => (
            <Row className="spacing-16" key={index}>
              <Col lg={12}>
                <span style={{ fontWeight: 500 }}>{`${formattedMessage(
                  'room',
                )} ${index + 1}:`}</span>
              </Col>
              <Col lg={12}>
                <Row className="spacing-16">
                  {room.roomPassengers.paxList.map((pax, pIndex) => {
                    const key = getKey(index, room, pIndex);
                    const error = passengerErrorDict[key] || {};
                    return (
                      <Col lg={12} key={pIndex}>
                        <Row className="spacing-16">
                          <div className="fs-16 fw-500 p-1 align-items-center">
                            <span className="fs-14 grey-color">
                              Traveller {pIndex + 1}
                            </span>
                          </div>
                          <Col lg={2}>
                            <AppSelect
                              label={formattedMessage('title')}
                              placeholder=""
                              classNamePrefix="hotel-booking-title"
                              className="app-select"
                              name="title"
                              required
                              options={
                                pax.paxType === '2'
                                  ? CHILD_TITLE_OPTIONS.map((d) => {
                                      return {
                                        value: d.value,
                                        label: d.label,
                                      };
                                    })
                                  : TITLE_OPTIONS.map((d) => {
                                      return {
                                        value: d.value,
                                        label: d.label,
                                      };
                                    })
                              }
                              selectedValue={pax.title}
                              onSelect={(value, name) =>
                                handleDropdownChange(value, name, index, pIndex)
                              }
                              isClearable={false}
                              errorText={
                                passengerErrorDict[getKey(index, room, pIndex)]
                                  ?.title
                              }
                            />
                          </Col>
                          <Col lg={3}>
                            <AppTextInput
                              label={formattedMessage('first_name')}
                              value={pax.firstName}
                              required
                              name="firstName"
                              onChange={(e) => handleChange(e, index, pIndex)}
                              errorText={error.firstName}
                            />
                            {checkValidName(pax.firstName) && (
                              <small className="app-error-text">
                                {formattedMessage('name_validation')}
                              </small>
                            )}
                          </Col>
                          <Col lg={3}>
                            <AppTextInput
                              label={formattedMessage('last_name')}
                              value={pax.lastName}
                              required
                              name="lastName"
                              onChange={(e) => handleChange(e, index, pIndex)}
                              errorText={error.lastName}
                            />
                            {checkValidName(pax.lastName) && (
                              <small className="app-error-text">
                                {formattedMessage('name_validation')}
                              </small>
                            )}
                            {getValueFromAppConfig(
                              'ENABLE_LASTNAME_VALIDATION',
                            ) === 'true' &&
                              !checkValidName(pax.lastName) &&
                              pax.lastName.trim().length > 0 &&
                              pax.lastName.trim().length < 2 && (
                                <small className="app-error-text ps-1">
                                  Last name must be 2+ letters
                                </small>
                              )}
                          </Col>
                          {pax.paxType !== '1' && (
                            <Col lg={3} md={3} sm={3}>
                              <AppTextInput
                                label="Age"
                                className="dob-input"
                                required
                                readOnly
                                value={pax.age}
                                name="dob"
                              />
                            </Col>
                          )}
                          {isPassport && (
                            <>
                              <Col lg={3}>
                                <AppTextInput
                                  label={formattedMessage('passport_number')}
                                  value={pax.ppNumber}
                                  name="ppNumber"
                                  required
                                  onChange={(e) =>
                                    handleChange(e, index, pIndex)
                                  }
                                  errorText={error.ppNumber}
                                />{' '}
                                {checkValidPassport(pax.ppNumber) && (
                                  <small className="app-error-text">
                                    Please enter valid passport number
                                  </small>
                                )}
                              </Col>
                              <Col lg={3}>
                                <AppTextInput
                                  label={formattedMessage('passport_expiry')}
                                  type="date"
                                  name="ppExpiry"
                                  min={formatDate(
                                    getNewDate(TODAY_DATE),
                                    API_DATE_FORMAT,
                                  )}
                                  value={pax.ppExpiry}
                                  onChange={(e) =>
                                    handleChange(e, index, pIndex)
                                  }
                                  errorText={error.ppExpiry}
                                />
                              </Col>
                            </>
                          )}
                          {isPan && pax.paxType === '1' && (
                            <Col lg={3}>
                              <AppTextInput
                                label={formattedMessage('pan_number')}
                                value={pax.panCardNumber}
                                name="panCardNumber"
                                required
                                onChange={(e) => handleChange(e, index, pIndex)}
                                errorText={error.panCardNumber}
                              />
                              {hasDuplicatePanCardNumber() && (
                                <small className="app-error-text">
                                  PAN Number Should be unique
                                </small>
                              )}
                              {PAN_REGAX.test(pax.panCardNumber) === false &&
                                !isEmpty(pax.panCardNumber) && (
                                  <small className="app-error-text">
                                    Enter Vaid PAN Number
                                  </small>
                                )}
                            </Col>
                          )}
                        </Row>
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            </Row>
          ))}
        </Row>
      )}
      {showAddPax && (
        <AppSidebar
          sidebarTitle="Add Traveller Details"
          onHideSidebar={() => setShowAddPax(false)}
          animatedClass="slide-from-right-animation"
          className="app-mobile-datepicker-modal"
        >
          <div className="p-3">
            <Row className="spacing-16">
              {/* Sidebar form content reused from main layout */}
              <Col lg={2}>
                <AppSelect
                  label={formattedMessage('title')}
                  name="title"
                  options={TITLE_OPTIONS}
                  selectedValue={selectedPax.title}
                  onSelect={handleSelectedTitleSelect}
                  isClearable={false}
                  errorText={errors.title}
                />
              </Col>
              <Col lg={3}>
                <AppTextInput
                  required
                  label={formattedMessage('first_name')}
                  value={selectedPax.firstName}
                  name="firstName"
                  onChange={handleTravellerInputChange}
                  errorText={errors.firstName}
                />
                {checkValidName(selectedPax.firstName) && (
                  <small className="app-error-text">
                    {formattedMessage('name_validation')}
                  </small>
                )}
              </Col>
              <Col lg={3}>
                <AppTextInput
                  required
                  label={formattedMessage('last_name')}
                  value={selectedPax.lastName}
                  name="lastName"
                  onChange={handleTravellerInputChange}
                  errorText={errors.lastName}
                />
                {checkValidName(selectedPax.lastName) && (
                  <small className="app-error-text">
                    {formattedMessage('name_validation')}
                  </small>
                )}
              </Col>
              {selectedPax.paxType !== '1' && (
                <Col lg={3}>
                  <AppTextInput
                    required
                    label={formattedMessage('dob')}
                    type="date"
                    className="dob-input"
                    name="dob"
                    max={formatDate(getNewDate(TODAY_DATE), API_DATE_FORMAT)}
                    value={selectedPax.dob}
                    onChange={handleTravellerInputChange}
                    errorText={errors.dob}
                  />
                </Col>
              )}
              {isPassport && (
                <>
                  <Col lg={3}>
                    <AppTextInput
                      label={formattedMessage('passport_number')}
                      name="ppNumber"
                      value={selectedPax.ppNumber}
                      onChange={handleTravellerInputChange}
                      errorText={errors.ppNumber}
                    />
                  </Col>
                  <Col lg={3}>
                    <AppTextInput
                      label={formattedMessage('passport_expiry')}
                      type="date"
                      name="ppExpiry"
                      min={formatDate(getNewDate(TODAY_DATE), API_DATE_FORMAT)}
                      value={selectedPax.ppExpiry}
                      onChange={handleTravellerInputChange}
                      errorText={errors.ppExpiry}
                    />
                  </Col>
                </>
              )}
              {isPan && selectedPax.paxType === '1' && (
                <Col lg={3}>
                  <AppTextInput
                    required
                    has
                    label={formattedMessage('pan_number')}
                    name="panCardNumber"
                    value={selectedPax.panCardNumber}
                    onChange={handleTravellerInputChange}
                    errorText={errors.panCardNumber}
                  />
                  {hasDuplicatePanCardNumber() && (
                    <small className="app-error-text">
                      PAN Number Should be unique
                    </small>
                  )}
                </Col>
              )}
            </Row>
            <AppButton
              className="w-100 mt-4 fs-16"
              btnText="Add"
              onClick={handleAddPax}
            />
          </div>
        </AppSidebar>
      )}
    </section>
  );
}

HotelPassengerDetails.propTypes = {
  passengerList: PropTypes.array.isRequired,
  onPassengerUpdate: PropTypes.func.isRequired,
  passengerErrorDict: PropTypes.object.isRequired,
  isPan: PropTypes.bool.isRequired,
  isPassport: PropTypes.bool.isRequired,
};

export default HotelPassengerDetails;
